import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { useAuthContext } from '../../../contexts/AuthContext';
import { useErrorMessage } from '../../../utils/errorMessage';

export const useCustomSubmit = ({
  setIsSubmitting,
  onUpdateResource,
  onCreateResource,
  purpose,
  setIsLoading,
  onGetResource,
  form,
  id
}) => {
  const { dispatchAPI } = useAuthContext();
  const navigate = useNavigate();
  const { message } = useErrorMessage();

  const customSubmit = async (body) => {
    setIsSubmitting(true);
    try {
      await dispatchAPI('PATCH', {
        url: `petsittingaddresses/form/${id}`,
        body:
          onUpdateResource?.setBody && purpose === 'edit'
            ? onUpdateResource.setBody(body)
            : onCreateResource.setBody(body)
      });
      navigate(-1);
    } catch (e) {
      // A request without answer has no response: the button must come back.
      if (e?.response?.data?.message?.includes?.('E11000')) {
        message('E11000', undefined, undefined, 'warning');
      } else {
        message(e);
      }
      setIsSubmitting(false);
    }
  };

  const getResource = useCallback(async () => {
    setIsLoading(true);
    try {
      const { data } = await dispatchAPI('GET', {
        url: `petsittingaddresses/form/${id || ''}?populate=dwelling_photos`
      });
      form.setFieldsValue(
        onGetResource?.setFields ? await onGetResource.setFields(data) : data
      );
    } catch (e) {
      message(e);
    }
    setIsLoading(false);
  }, [purpose]);

  return { customSubmit, getResource };
};
